const DB_NAME = 'member-nest-event-admissions';
const DB_VERSION = 1;
const ROSTERS = 'rosters';
const QUEUE = 'queue';

function openDb() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') return reject(new Error('Offline storage is unavailable.'));
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(ROSTERS)) db.createObjectStore(ROSTERS, { keyPath: 'key' });
      if (!db.objectStoreNames.contains(QUEUE)) db.createObjectStore(QUEUE, { keyPath: 'id' });
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function transaction(storeName, mode, run) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, mode);
    const store = tx.objectStore(storeName);
    const result = run(store);
    tx.oncomplete = () => { db.close(); resolve(result); };
    tx.onerror = () => { db.close(); reject(tx.error); };
  });
}

export function admissionRosterKey(teamId, eventId, occurrenceId = '') {
  return `${teamId}:${eventId}:${occurrenceId || 'event'}`;
}

export async function cacheAdmissionRoster({ key, rows, expiresAt }) {
  return transaction(ROSTERS, 'readwrite', store => store.put({ key, rows, expiresAt, cachedAt: Date.now() }));
}

export async function readCachedAdmissionRoster(key) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(ROSTERS, 'readwrite');
    const store = tx.objectStore(ROSTERS);
    const request = store.get(key);
    request.onsuccess = () => {
      const value = request.result;
      if (value && Number(value.expiresAt || 0) <= Date.now()) store.delete(key);
      resolve(value && Number(value.expiresAt || 0) > Date.now() ? value.rows || [] : []);
    };
    request.onerror = () => reject(request.error);
    tx.oncomplete = () => db.close();
    tx.onerror = () => { db.close(); reject(tx.error); };
  });
}

export async function queueAdmissionAction(action) {
  const id = action.id || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  await transaction(QUEUE, 'readwrite', store => store.put({ ...action, id, queuedAt: Date.now() }));
  return id;
}

export async function listQueuedAdmissionActions(key) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(QUEUE, 'readonly');
    const request = tx.objectStore(QUEUE).getAll();
    request.onsuccess = () => { db.close(); resolve((request.result || []).filter(row => row.key === key).sort((a, b) => a.queuedAt - b.queuedAt)); };
    request.onerror = () => { db.close(); reject(request.error); };
  });
}

export async function removeQueuedAdmissionAction(id) {
  return transaction(QUEUE, 'readwrite', store => store.delete(id));
}

export async function clearAdmissionOfflineData() {
  if (typeof indexedDB === 'undefined') return;
  await new Promise(resolve => {
    const request = indexedDB.deleteDatabase(DB_NAME);
    request.onsuccess = request.onerror = request.onblocked = () => resolve();
  });
}
